import React from "react";

const LabelsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <path
        d="M9.48125 14.0252C9.25625 14.2341 8.98438 14.3386 8.66563 14.3386C8.34688 14.3386 8.075 14.2341 7.85 14.0252L0.81875 7.49615C0.69375 7.38008 0.609375 7.2582 0.565625 7.13052C0.521875 7.00285 0.5 6.86936 0.5 6.73008V1.43722C0.5 1.13544 0.60625 0.885882 0.81875 0.68856C1.03125 0.491239 1.3 0.392578 1.625 0.392578H7.325C7.475 0.392578 7.625 0.412891 7.775 0.453516C7.925 0.494141 8.0625 0.572489 8.1875 0.68856L15.1813 7.18276C15.4188 7.40329 15.5375 7.66155 15.5375 7.95753C15.5375 8.25351 15.4188 8.51177 15.1813 8.73231L9.48125 14.0252ZM3.59375 4.15329C3.85625 4.15329 4.08438 4.06334 4.27813 3.88343C4.47188 3.70352 4.56875 3.49168 4.56875 3.24793C4.56875 3.00418 4.47188 2.79235 4.27813 2.61244C4.08438 2.43253 3.85625 2.34258 3.59375 2.34258C3.33125 2.34258 3.10313 2.43253 2.90938 2.61244C2.71563 2.79235 2.61875 3.00418 2.61875 3.24793C2.61875 3.49168 2.71563 3.70352 2.90938 3.88343C3.10313 4.06334 3.33125 4.15329 3.59375 4.15329Z"
        fill="#ACACAC"
      />
    </svg>
  );
};

export default LabelsIcon;
